<template>
  <router-link v-if="item.to" :to="{ name: item.to }" class="d-flex flex-row align-center">
    <v-icon v-if="item.icon" v-html="item.icon"/>
    <v-avatar v-if="item.fresh"
    class="flex-0-1-auto mr-2 ml-n3"
    color="#4287f5"
    size="4"/>
    {{ $t(item.name) }}
  </router-link>
  <a v-else href="#" class="d-flex flex-row align-center"
   @click="(e) => {e.preventDefault(); return false}"
  >
    <v-icon v-if="item.icon" v-html="item.icon"/>
    <v-avatar v-if="item.fresh"
    class="flex-0-1-auto mr-2 ml-n3"
    color="#4287f5"
    size="4"/>
    {{ $t(item.name) }}
  </a>
</template>

<script>
export default {
  name: 'DefaultListItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
